module.exports = __webpack_public_path__ + "img/1970East-043_WEB-min.2f5124a8.jpg";